<template>
  <span id="upload-to-versapay" v-if="invoices.total">
    <el-button id="btn-upload-to-versapay" v-if="!isInUploadToVersapay && !isDropDownItem" type="success" plain
               @click="handleToggleUploadToVersapay(true)" size="mini">
      {{ $t('invoices.uploadToVersapay') }}
    </el-button>
    <el-dropdown-item id="btn-upload-to-versapay-dropdown-item" v-if="!isInUploadToVersapay && isDropDownItem"
                      type="success" plain @click.native="handleToggleUploadToVersapay(true)"
                      size="mini">
      <span class="more-actions-option">{{ $t('invoices.uploadToVersapay') }}</span>
    </el-dropdown-item>
    <el-button id="btn-cancel-upload-to-versapay" v-if="isInUploadToVersapay && !isDropDownItem" type="default"
               @click="handleToggleUploadToVersapay(false)" size="mini">
      {{ $t('common.cancel') }}
    </el-button>
    <el-button id="btn-submit-print-invoice-bulk" v-if="isInUploadToVersapay && !isDropDownItem" type="primary"
               @click="uploadToVersapay" size="mini">{{ $t('invoices.uploadToVersapay') }}</el-button>
  </span>
</template>

<script>
import { Loading, Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'UploadToVersapay',
  props: {
    isDropDownItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['invoices', 'isInUploadToVersapay'])
  },
  data() {
    return {};
  },
  methods: {
    handleToggleUploadToVersapay(isInUploadToVersapay) {
      this.$store.dispatch('invoices/setIsInUploadToVersapay', isInUploadToVersapay);
    },
    async uploadToVersapay() {
      if (this.invoices.selectAllChecked || this.invoices.selectedIdsIncluded.length) {
        Message.closeAll();
        const loading = Loading.service(constants.LOADING.DEFAULT_CONFIG);
        this.$message.warning(this.$t('invoices.list.uploadToVersapayWarning'));
        await this.$store.dispatch('invoices/uploadToVersapay');
        loading.close();
        this.handleToggleUploadToVersapay(false);
      } else {
        this.$message.warning(this.$t('invoices.list.selectInvoicesToUploadToVersapay'));
      }
    }
  },
  beforeDestroy() {
    this.handleToggleUploadToVersapay(false);
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
#print-invoice-bulk {
  .el-button--success {
    margin-left: 10px;
  }
}

#print-invoice-bulk-dialog {
  .el-button {
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
